// Angular
import { Component, Input } from '@angular/core';
// Layout
import { LayoutConfigService, OffcanvasOptions } from '../../../../core/_base/layout';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddNoteDialogComponent } from 'src/app/views/pages/apps/lists/notes/add-note-dialog/add-note-dialog.component';
import { DisplayNoteMessage, Note, NoteMode } from 'src/app/core/lists';
import { ChooseTemplateDialogComponent } from 'src/app/views/pages/calendar/choose-template/choose-template.dialog.component';
import { Observable } from 'rxjs';
import { ContextualHistoryService } from '../../content/general/contextual-history/services/contextual-history.service';
import { TaskService, TimelineService } from '../../../../core/timeline';
import { SendMessageDialogComponent } from '../../../pages/calendar/send-message-dialog/send-message.dialog.component';
import { MessageType } from '../../../../core/_base/crud';
import { switchMap, take } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
import { TranslateService } from '@ngx-translate/core';
import { currentUser } from '../../../../core/auth';
import { TaskMode, TaskPriority, TaskStatus } from '../../../pages/calendar/enums';
import { CreateTaskComponent } from '../../../pages/calendar/create-task/create-task.component';

@Component({
  selector: 'kt-sticky-toolbar',
  templateUrl: './sticky-toolbar.component.html',
  styleUrls: ['./sticky-toolbar.component.scss'],
})
export class StickyToolbarComponent {
  // Public properties
  demoPanelOptions: OffcanvasOptions = {
    overlay: true,
    baseClass: 'offcanvas',
    placement: 'right',
    closeBy: 'kt_demo_panel_close',
    toggleBy: 'kt_demo_panel_toggle',
  };
  showTimelineIcon$: Observable<boolean>;
  baseHref: string;
  currentUser;
  @Input() filteredView = false;

  constructor(
    private store: Store<AppState>,
    private translate: TranslateService,
    private taskService: TaskService,
    private timeline: TimelineService,
    private layoutConfigService: LayoutConfigService,
    private contextualHistoryService: ContextualHistoryService,
    public dialog: MatDialog,
  ) {
    this.baseHref = 'https://keenthemes.com/metronic/preview/angular/';
    this.showTimelineIcon$ = this.contextualHistoryService.showIconSub.asObservable();
    this.store.select(currentUser).subscribe((res) => (this.currentUser = res));
  }

  isActiveDemo(demo) {
    return demo === this.layoutConfigService.getConfig('demo');
  }

  createTask() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '30vw';
    this.dialog.open(ChooseTemplateDialogComponent, dialogConfig);
  }
  sendMessage() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '30vw';
    this.dialog.open(SendMessageDialogComponent, dialogConfig);
  }

  createTaskFromNote(note: Note): void {
    this.store
      .pipe(
        select(currentUser),
        switchMap((user) =>
          this.taskService.createTaskV3({
            id: null,
            task_entities: note.entities?.map((e) => ({ entity_id: e.id })) || [],
            task_tags: [],
            task_attachments: [],
            allow_payment: false,
            steps: [
              {
                id: null,
                title: note.subject,
                order: 1,
                default_view: null,
                priority: TaskPriority.LOW,
                progress: TaskStatus.PLANNED,
                office_id: null,
                description: note.description,
                url_resource: null,
                due_date: null,
                sequential_order: false,
                task_template: null,
                task_followers: [{ follower_id: user?.id }],
                task_responsible_users: [],
                blockers: null,
                check_list: null,
                intervention: null,
                transaction_form: null,
              },
            ],
          }),
        ),
        take(1),
      )
      .subscribe((res) => {
        if (!res?.data) return;

        this.store.dispatch(
          new DisplayNoteMessage({
            message: this.translate.instant('NOTE.CREATE_TASK_MESSAGE'),
            messageType: MessageType.Create,
          }),
        );

        setTimeout(() => {
          const dialogConfig = new MatDialogConfig();

          dialogConfig.disableClose = true;
          dialogConfig.closeOnNavigation = true;
          dialogConfig.width = '95vw';
          dialogConfig.maxWidth = '95vw';
          dialogConfig.data = { mode: TaskMode.UPDATE, task: res.data };

          this.dialog.open(CreateTaskComponent, dialogConfig);
        }, 1000);
      });
  }

  createNote() {
    const dialogRef = this.dialog.open(AddNoteDialogComponent, {
      disableClose: true,
      closeOnNavigation: true,
      width: '95vw',
      maxWidth: '95vw',
      data: { mode: NoteMode.CREATE, fromContact: false, note: new Note() },
    });

    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe((res) => {
        if (!res?.note) return;

        this.store.dispatch(
          new DisplayNoteMessage({
            message: this.translate.instant('NOTE.CREATE_MESSAGE'),
            messageType: MessageType.Create,
          }),
        );

        if (res.note.createTask) setTimeout(() => this.createTaskFromNote(res.note), 1000);
      });
  }

  loadTimeline() {
    this.timeline.loadTimeline$.next(false);
    this.timeline.loadTimeline$.next(true);
  }
}
